import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronDown, Loader2 } from "lucide-react";

// Load-more button or infinite scroll. Auto-loading stops at `cap`, then falls back to a button (or a View all link).
export const FreshMore = ({ mode, hasMore, count, onMore, t, cap = 48, afterCap = "link", loading = false, label, testid = "fresh" }) => {
  const ref = useRef(null);
  const auto = mode === "scroll" && count < cap;
  useEffect(() => {
    if (!auto || !hasMore || loading || !ref.current) return;
    const io = new IntersectionObserver((es) => es[0].isIntersecting && onMore(), { rootMargin: "300px" });
    io.observe(ref.current);
    return () => io.disconnect();
  }, [auto, hasMore, onMore, count, loading]);

  if (!hasMore) return null;
  if (auto) {
    return (
      <div ref={ref} className="mt-8 flex justify-center text-slate-400" data-testid={`${testid}-scroll-sentinel`}>
        <Loader2 size={20} className="animate-spin" />
      </div>
    );
  }
  const link = mode === "scroll" && afterCap === "link";
  return (
    <div className="mt-8 flex justify-center">
      {link
        ? <Link to="/browse" data-testid={`${testid}-view-all`} className="inline-flex items-center gap-2 h-11 px-6 rounded-full bg-[#12234A] text-white font-semibold hover:bg-[#0c1834] transition-colors">{t("view_all")} <ArrowRight size={18} /></Link>
        : <button onClick={onMore} disabled={loading} data-testid={`${testid}-load-more`}
            className="inline-flex items-center gap-2 h-11 px-6 rounded-full border-2 border-[#12234A] text-[#12234A] font-semibold hover:bg-[#12234A] hover:text-white transition-colors disabled:opacity-60">
            {loading ? <Loader2 size={18} className="animate-spin" /> : <ChevronDown size={18} />} {label || t("fresh_load_more")}
          </button>}
    </div>
  );
};
